import React from 'react';
import { Button, DialogContent, DialogTitle, InputAdornment, IconButton, TextField, Avatar, Grid2, Checkbox, FormControlLabel } from '@mui/material';
import { Dialog } from '@mui/material';
import { Close as CloseIcon, Category as CategoryIcon } from '@mui/icons-material';
import { QuickOrderProduct } from '../../../types';
import { useGetCompanyVendorProfileQuery } from '../../../services/vendorProfile';
import { CURRENCY_SYMBOLS } from '../../../types';
import { Currencies } from '../../../types';
import useAuth from '../../../components/Auth';

interface Props {
    onSubmit: (payload: Partial<QuickOrderProduct> & {isBundled?: boolean}) => void;
    onClose: () => void;
	open: boolean;
    product: QuickOrderProduct | null;
}

const QuickOrderEditProductDialog = ({ onSubmit, onClose, open, product }: Props) => {
	const {userProfile} = useAuth();
	const {data: vendorProfile} = useGetCompanyVendorProfileQuery(undefined, {skip: !userProfile});
	const currencySymbol = CURRENCY_SYMBOLS[vendorProfile?.currency as Currencies];

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const formData = new FormData(e.target as HTMLFormElement);
		onSubmit({
			...Object.fromEntries(formData),
			isBundled: formData.get('isBundled') === 'on'
		} as Partial<QuickOrderProduct> & {isBundled?: boolean});
	};

	return <Dialog open={open} fullWidth onClose={onClose}>
		<DialogTitle>
			{product?.name}
		</DialogTitle>
		<IconButton onClick={onClose} sx={(theme) => ({
			position: 'absolute',
			right: 8,
			top: 8,
			color: theme.palette.grey[500],
		})}>
			<CloseIcon />
		</IconButton>
		<DialogContent>
			{product && <form onSubmit={handleSubmit}>
				<Grid2 container spacing={2}>
					<Grid2>
						<TextField disabled fullWidth required autoComplete='off' label='SKU' name='sku' defaultValue={product.sku} />
					</Grid2>
					<Grid2 size={12}>
						<TextField disabled fullWidth required autoComplete='off' label='Name' name='name' defaultValue={product.name} />
					</Grid2>
					<Grid2 size='grow'>
						<TextField required autoComplete='off' label='Unit of measure' name='uom' defaultValue={product.uom} />
					</Grid2>
					<Grid2 size='grow'>
						<TextField required autoComplete='off' label='Quantity' name='quantity' defaultValue={product.quantity} />
					</Grid2>
					<Grid2 size='grow'>
						<TextField required type='number' autoComplete='off' label='Price per unit' name='pricePerUnit' defaultValue={product.pricePerUnit ?? ''} InputProps={{
							endAdornment: <InputAdornment position="end">{currencySymbol}</InputAdornment>,
						}}/>
					</Grid2>
					<Grid2 size={12}>
						<TextField disabled autoComplete='off' label='Image URL' name='imgUrl' defaultValue={product.imgUrl} />
						<Avatar sx={{width: 96, height: 96}} sizes='large' variant='square' src={product.imgUrl}>
							<CategoryIcon fontSize='large' />
						</Avatar>
					</Grid2>
					<Grid2 size={12}>
						<FormControlLabel name='isBundled' control={<Checkbox defaultChecked={product.bundleProductId !== null} />} disabled={product.isBundle} label='Is bundled' />
					</Grid2>
					<Grid2 size={12}>
						<Button type='submit' variant='contained'>Update</Button>
					</Grid2>
				</Grid2>
			</form>}
		</DialogContent>
	</Dialog>;   
};

export default QuickOrderEditProductDialog;
